"use client"
import { Modal } from "@/components/modal";
import { useRouter } from "next/navigation";

interface LikeModalProps {    
    isOpen: boolean;
    onOpenChange: (isOpen: boolean) => void;
    id: number;
}

export function LikeModal({isOpen, onOpenChange, id}: LikeModalProps) {
    const router = useRouter()
    return (
        <Modal isOpen={isOpen} onOpenChange={onOpenChange} title={"Obrigado pelo seu voto"} closeButton={{label: "Não"}} buttons={[{label: "Sim, quero relatar", onClick: () => router.push(`/votacao/problemas/${id}?relato=true`, {scroll: false})}]}>
            <div>
                Você gostaria de compartilhar como esse problema afeta a sua vida ou a da sua comunidade?
            </div>
        </Modal>
    )
}